import React, { useState } from 'react'
import Button from '@material-ui/core/Button'
import IcoNewItemSrc from 'assets/img/ico-new-item-18px.svg'
import { MenuItem, Popover } from '@material-ui/core'
import useTranslation from 'Hooks/useTranslation'
import useAddBoxSelect from 'Hooks/useAddBoxSelect'

const IcoNewItem = () => <img src={IcoNewItemSrc} alt="" />

const AddBoxMenu = props => {
    const translation = useTranslation();
    // inline: no button and popover, only the items are rendered (mobile actions menu), onClose is called after select
    const { onAddBox, itemTypes, currentUnitModel, inline = false, onClose } = props

    const selectBox = useAddBoxSelect(onAddBox, currentUnitModel)

    const [addItemMenuAnchorEl, onAddItemMenuAnchorElChange] = useState(null)

    const closeAddItemMenu = () => {
        onAddItemMenuAnchorElChange(null)
        if (inline && onClose) onClose()
    }

    const handleMenuSelect = menuItem => {
        closeAddItemMenu()
        selectBox(menuItem)
    }

    const renderItems = () => itemTypes.map(item =>
        <div key={item.itemType}>
            <MenuItem
            className='addBoxMenuItem'
            disabled={!item.isAvailable}
            id={`addItemMenuBtn-${item.itemType}`}
            onClick={() => handleMenuSelect(item.itemType)}
        >{item.name}</MenuItem>
        </div>
    )

    if (inline) {
        return itemTypes ? renderItems() : null
    }

    return (
        <div>
            <Button className="addItem"
                variant="contained"
                color="primary"
                startIcon={<IcoNewItem />}
                id="addItemMenuBtn"
                onClick={(e) => onAddItemMenuAnchorElChange(e.target)}>
                {translation.dashboardNewItemLabel}
            </Button>
            {
                itemTypes && (
                    <Popover
                        anchorEl={addItemMenuAnchorEl}
                        keepMounted
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
                        style={{top: '10px', left: '-10px'}}
                        disableScrollLock={true}
                        open={Boolean(addItemMenuAnchorEl)}
                        onClose={closeAddItemMenu}
                    >
                        {renderItems()}
                    </Popover>
                )
            }
        </div>
    )
}

export default AddBoxMenu
